
export default "/assets/envelope-micro.e8df9957.svg"